var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnContentAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.42236V3.96736C12.6675 4.61236 14.25 6.62236 14.25 8.99986C14.25 11.3774 12.6675 13.3799 10.5 14.0249V15.5774C13.5 14.8949 15.75 12.2099 15.75 8.99986C15.75 5.78986 13.5 3.10486 10.5 2.42236ZM12.375 8.99986C12.375 7.67236 11.625 6.53236 10.5 5.97736V11.9999C11.625 11.4674 12.375 10.3199 12.375 8.99986ZM2.25 6.74986V11.2499H5.25L9 14.9999V2.99986L5.25 6.74986H2.25Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnContentAudio);
export default __webpack_public_path__ + "static/media/icn_content_audio.f8af388e9b40b06f697af592baa4e0c8.svg";
export { ForwardRef as ReactComponent };